import { Injectable } from "@angular/core";
import { Subject, Observable, BehaviorSubject } from "rxjs";
import { AngularFireAuth } from "@angular/fire/auth";
import * as firebase from "firebase";
import { MDBModalService, MDBModalRef } from "ng-uikit-pro-standard";
import { NoAccessComponent } from "src/app/login/components/popups/no-access/no-access.component";

@Injectable({
  providedIn: "root"
})
export class AuthService {
  private isAdmin: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  private isOwner: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  private loggedIn: Subject<boolean> = new Subject<boolean>();

  private user$: Subject<string> = new Subject<string>();

  modalRef: MDBModalRef;

  get user(): firebase.User {
    return this.af.auth.currentUser;
  }
  constructor(
    public af: AngularFireAuth,
    private modalService: MDBModalService
  ) {
    this.subscribe();
  }
  openError = () =>
    (this.modalRef = this.modalService.show(NoAccessComponent, {
      ignoreBackdropClick: false,
      class: "modal-center ",
      containerClass: "center",

      animated: true
    }));

  closeError = () => this.modalRef.hide();
  subscribe = () => this.af.authState.subscribe(() => this.updateLoginState());

  updateLoginState() {
    if (this.user != null) {
      this.updateUser();
    } else {
      this.loggedIn.next(false);
    }
  }

  get isLoggedIn(): Observable<boolean> {
    return this.loggedIn.asObservable();
  }

  get owner(): boolean {
    return this.isOwner.value;
  }

  get admin(): boolean {
    return this.isAdmin.value;
  }

  changeAdmin = (value: boolean) => this.isAdmin.next(value);

  changeOwner = (value: boolean) => this.isOwner.next(value);

  doGoogleLogin() {
    return new Promise<any>((resolve, reject) => {
      let provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope("profile");
      provider.addScope("email");
      provider.setCustomParameters({
        login_hint: "user@example.com",
        prompt: "select_account"
      });
      this.af.auth.signInWithPopup(provider).then(res => {
        resolve(res);
        firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
      });
    });
  }


  async exists(email: string): Promise<boolean> {
    let x = await firebase.auth().fetchSignInMethodsForEmail(email);
    return x.length != 0;
  }

  async signInWithEmailAndPassword(
    email: string,
    password: string,
    remember: boolean
  ): Promise<void> {
    let persistence = remember
      ? firebase.auth.Auth.Persistence.LOCAL
      : firebase.auth.Auth.Persistence.NONE;
    await firebase.auth().setPersistence(persistence);
    await firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .catch(reject => {
        this.openError();
      });
  }

  logout = () => this.af.auth.signOut();

  canAccess = (type: string) =>
    type != null && (type == "LineLeapAdmin" || type == "VenueAdmin");

  updateUser() {
    this.user.getIdTokenResult().then(token => {
      if (this.canAccess(token.claims.access_type)) {
        this.changeAdmin(token.claims.access_type == "LineLeapAdmin");
        this.changeOwner(token.claims.access_type == "VenueAdmin");
        this.loggedIn.next(true);
      } else {
        this.af.auth.signOut();
        this.openError();
      }
    });
  }

  disableAllPrivileges() {
    this.changeAdmin(false);
    this.changeOwner(false);
  }

  sendPasswordResetEmail(email: string) {
    firebase.auth().sendPasswordResetEmail(email);
  }
}
